import {call, put} from 'redux-saga/effects';
import {unassignPubEditor} from 'services/pubs';
import {handleError} from 'store/app/error/saga';

import {getSingleEditorACS, unassignPubACS} from '../requestAC';

export function* unassignPubSaga(action: ReturnType<typeof unassignPubACS>) {
  const {editorId, assignedPubId, pubId} = action.payload;

  try {
    yield call(unassignPubEditor, pubId, assignedPubId);
    yield put(getSingleEditorACS(editorId));
  } catch (error) {
    yield call(handleError, error, 'Failed to remove pub from editor');
  }
}
